import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import { faker } from '@faker-js/faker';

export const randomQCTaskUploads = () => ({
  siteUserName: faker.person.fullName(),
  siteUserId: faker.string.uuid(),
  uploadDate: faker.date.past(),
  visitId: faker.string.uuid(),
  siteId: faker.string.uuid(),
  taskUploadId: faker.string.uuid(),
  verifications: [
    {
      id: faker.string.uuid(),
      status: faker.string.fromCharacters(['WARNING', 'RESOLVED', 'SUCCESS']),
      type: faker.word.noun(),
      title: faker.word.noun(),
      message: faker.word.noun(),
      comment: faker.lorem.sentence(),
      index: faker.number.int(),
    },
  ],
  status: faker.string.fromCharacters([
    'CREATED',
    'UPLOADED',
    'FAILED',
    'NOT_VALID',
    'DELETED',
    'VALIDATED',
    'ANONYMIZED',
    'DICOM_UPLOADED',
    'COMPLETE',
  ]),
  preProcessingStatus: faker.string.fromCharacters([
    'CREATED',
    'UPLOADED',
    'NOT_VALID',
    'VALIDATED',
    'PARSING_FAILED',
  ]),
  workflows: [
    {
      started: faker.date.past(),
      finished: faker.date.past(),
      type: faker.string.fromCharacters(['PARSER', 'ANONYMIZER']),
      status: faker.string.fromCharacters([
        'IN_PROGRESS',
        'COMPLETED',
        'FAILED',
      ]),
      executionId: faker.string.uuid(),
    },
  ],
  comment: faker.lorem.sentence(),
});

const generateResponse = (number: number) => {
  return new Array(number).fill(undefined).map(randomQCTaskUploads);
};

export const fetchQCTaskUploadsMock = async (taskId: string) => {
  const data = generateResponse(faker.number.int({ min: 1, max: 10 }));
  axiosMock
    .onGet(API_URL.qcTaskUploads.replace(':taskId', taskId))
    .reply(200, data);
  axiosMock.onGet(API_URL.qcTaskUploads.replace(':taskId', taskId));
};
